import { render, staticRenderFns } from "./MenuListPage.vue?vue&type=template&id=09680e3d&"
import script from "./MenuListPage.vue?vue&type=script&lang=js&"
export * from "./MenuListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports